// Copyright (c) StrangeBee 2024

import { Form, FormInstance } from 'antd';
import { useState } from 'react';

export interface UseValidateFormReturn<T = any> {
    form: FormInstance<T>;
    isValid: boolean;
    onFormValuesChange: () => void;
    setFieldsTouched: React.Dispatch<React.SetStateAction<boolean>>;
    fieldsTouched: boolean;
    loading: boolean;
    setLoading: React.Dispatch<React.SetStateAction<boolean>>;
}

interface UseValidateFormProps {
    isValidInit?: boolean;
    fieldsTouchedInit?: boolean;
}

const useValidateForm = <T = any>(props?: UseValidateFormProps): UseValidateFormReturn<T> => {
    const [form] = Form.useForm<T>();
    const [isValid, setIsValid] = useState<boolean>(props?.isValidInit || false);
    const [fieldsTouched, setFieldsTouched] = useState(props?.fieldsTouchedInit || false);
    const [loading, setLoading] = useState(false);

    const checkFormValidity = () => {
        form.validateFields()
            .then(() => {
                setIsValid(true);
            })
            .catch((error) => {
                setIsValid(false);

                error.errorFields.forEach((errorField: any) => {
                    const name = errorField.name[0];
                    if (!form.isFieldTouched(name)) {
                        form.setFields([
                            {
                                name,
                                errors: [],
                            },
                        ]);
                    }
                });
            });
    };

    const onFormValuesChange = () => {
        setTimeout(checkFormValidity);
    };

    return {
        form,
        isValid,
        onFormValuesChange,
        fieldsTouched,
        setFieldsTouched,
        loading,
        setLoading,
    };
};

export default useValidateForm;
